import { BoxGeometry, Vector3 } from 'three';
import { SpatialEntityComponent, SpatialEntityComponentType, } from './component.js';
export class Bounded3DComponent extends SpatialEntityComponent {
    constructor(spatialEntity, initData) {
        super(spatialEntity);
        this._offset = new Vector3();
        this._extent = new Vector3();
        this.type = SpatialEntityComponentType.Bounded3D;
        const { offset, extent } = initData;
        this._offset.set(offset.x, offset.y, offset.z);
        this._extent.set(extent.width, extent.height, extent.depth);
        this.buildGeometry();
    }
    buildGeometry() {
        var _a;
        const geometry = new BoxGeometry(this._extent.x, this._extent.y, this._extent.z);
        geometry.translate(this._offset.x + this._extent.x / 2, this._offset.y + this._extent.y / 2, this._offset.z + this._extent.z / 2);
        (_a = this._spatialEntity.geometry) === null || _a === void 0 ? void 0 : _a.dispose();
        this._spatialEntity.geometry = geometry;
    }
    get offset() {
        return this._offset;
    }
    get extent() {
        return this._extent;
    }
    get initData() {
        return {
            offset: this.offset,
            extent: this.extent,
        };
    }
    get pbData() {
        return {
            offset: { x: this._offset.x, y: this._offset.y, z: this._offset.z },
            extent: {
                width: this._extent.x,
                height: this._extent.y,
                depth: this._extent.z,
            },
        };
    }
}
//# sourceMappingURL=bounded3d.js.map